<template>
  <div v-if="!isFullscreen" class="footer-license">
    <div class="footer-license-row">
      <span class="license-right">تمام حقوق مادی و معنوی این سامانه متعلق به شرکت <a href="https://sinapardazesh.ir" target="_blank" class="company-link">سیناپردازش نوین آریا</a> است.</span>
      <span class="license-left">
        <span class="footer-links">
          <a href="https://www.sinapardazesh.ir/%d8%af%d8%b1%d8%a8%d8%a7%d8%b1%d9%87-%d9%85%d8%a7/" target="_blank" rel="noopener noreferrer" class="footer-link">درباره ما</a>
          <a href="https://www.sinapardazesh.ir/%d8%aa%d9%84%d9%81%d9%86%d8%8c-%d9%be%d8%b3%d8%aa-%d8%a7%d9%84%da%a9%d8%aa%d8%b1%d9%88%d9%86%db%8c%da%a9%d8%8c-%d9%86%d8%b4%d8%a7%d9%86%db%8c/" target="_blank" rel="noopener noreferrer" class="footer-link">تماس با ما</a>
        </span>
      </span>
    </div>
  </div>
  <!-- Mobile-only footer: visible when width <= 768px and hidden on desktop -->
  <div v-if="!isFullscreen" class="footer-license-mobile">
    <div class="footer-license-row">
      <div class="license-mobile-column">
        <span class="license-mobile-text">تمام حقوق مادی و معنوی این سامانه متعلق به شرکت <a href="https://sinapardazesh.ir" target="_blank" class="company-link">سیناپردازش نوین آریا</a> است.</span>
        <div class="footer-links-mobile">
          <a href="https://www.sinapardazesh.ir/%d8%af%d8%b1%d8%a8%d8%a7%d8%b1%d9%87-%d9%85%d8%a7/" target="_blank" rel="noopener noreferrer" class="footer-link">درباره ما</a>
          <a href="https://www.sinapardazesh.ir/%d8%aa%d9%84%d9%81%d9%86%d8%8c-%d9%be%d8%b3%d8%aa-%d8%a7%d9%84%da%a9%d8%aa%d8%b1%d9%88%d9%86%db%8c%da%a9%d8%8c-%d9%86%d8%b4%d8%a7%d9%86%db%8c/" target="_blank" rel="noopener noreferrer" class="footer-link">تماس با ما</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
const route = useRoute();
const isFullscreen = computed(() => route.query.fullscreen === '1');
</script>

<style scoped>
.footer-license {
  display: flex;
  align-items: center;
  /* On RTL pages, flex-start aligns to the right; use flex-end to align visually left */
  justify-content: flex-end;
  bottom: 0;
  padding: 7px 5px;
  direction: rtl;
  background-color: var(--hover-background-color);
  z-index: 10;
  position: fixed;
  width: calc(100% - 0rem);
}

.footer-license-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* Ensure the grid starts at the visual left of the container */
  justify-items: start;
  justify-self: end;
}

.license-right {
  text-align: center;
  justify-self: center;
}

.license-left {
  text-align: left;
  justify-self: left;
}

.company-link {
  text-decoration: none;
  color: blue;
}

.phone-link {
  text-decoration: none;
}

.footer-links {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px; /* add 10px spacing from the left */
}
.footer-link {
  text-decoration: none;
  color: var(--text-color-primary);
  font-weight: 500;
}
.footer-link:hover {
  text-decoration: underline;
}
.license-mobile-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer-links-mobile {
  display: flex;
  gap: 1rem;
  margin-top: 6px;
  padding-left: 10px; /* add 10px spacing from the left on mobile */
}

@media only screen and (max-width: 1064px) {
  .footer-license {
    width: 100% !important;
  }
}

@media only screen and (max-width: 768px) {
  .footer-license {
    display: none !important; /* hide footer on mobile */
  }
}

/* Mobile footer styles */
.footer-license-mobile {
  display: none;
}
@media only screen and (max-width: 768px) {
  .footer-license-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    padding: 8px 10px;
    direction: rtl;
    background-color: var(--hover-background-color);
    z-index: 10;
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
  }
  .footer-license-mobile .footer-license-row {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .footer-license-mobile .license-mobile-text {
    text-align: center;
    color: var(--text-color-primary);
  }
}
</style>
